import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";

import OrderCard from "./OrderCard";

const styles = (theme) => ({
  root: {
    width: "100%",
    maxWidth: 1400,
    margin: "0 auto",
    padding: theme.spacing(1),
    boxSizing: "border-box",
  },
});

class OrderList extends React.Component {
  render() {
    const { classes, orders, products, during, token } = this.props;
    const visibleOrders = orders.filter(
      (order) => order && order.isPaymentSimulation !== true
    );

    return (
      <div className={classes.root}>
        {visibleOrders.map((order) => {
          return (
            <OrderCard
              during={during}
              key={order.orderId}
              data={order}
              token={token}
              products={products}
              onGetPaymentDetails={this.props.onGetPaymentDetails}
              onUpdateStatus={this.props.onUpdateStatus}
              onUpdateTrackingCode={this.props.onUpdateTrackingCode}
              onResendPurchaseEmails={this.props.onResendPurchaseEmails}
            />
          );
        })}
      </div>
    );
  }
}

OrderList.propTypes = {
  classes: PropTypes.object.isRequired,
  orders: PropTypes.array,
  during: PropTypes.bool,
  token: PropTypes.string,
  products: PropTypes.array,
  onGetPaymentDetails: PropTypes.func,
  onUpdateStatus: PropTypes.func,
  onUpdateTrackingCode: PropTypes.func,
  onResendPurchaseEmails: PropTypes.func,
};

export default withStyles(styles)(OrderList);
